import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatMetricValue } from '../lib/platforms';
import type { AnalyticsMetric } from '../lib/types';

interface MetricCardProps {
  metric: AnalyticsMetric;
}

const MetricCard: React.FC<MetricCardProps> = ({ metric }) => {
  const hasChange = typeof metric.change !== 'undefined';
  const isPositive = hasChange && metric.change > 0;

  return (
    <div className="bg-[#151632]/50 backdrop-blur-sm p-6 rounded-xl border border-[#1E2048] hover:border-purple-500/25 transition-all duration-300">
      <h3 className="text-gray-400 text-sm">{metric.label}</h3>
      <div className="mt-2 flex items-baseline">
        <p className="text-2xl font-bold text-white">
          {formatMetricValue(metric.value, metric.format)}
        </p>
        {hasChange && (
          <span className={`ml-2 flex items-center text-sm ${
            isPositive ? 'text-green-400' : 'text-red-400'
          }`}>
            {isPositive ? (
              <TrendingUp className="h-4 w-4 mr-1" />
            ) : (
              <TrendingDown className="h-4 w-4 mr-1" />
            )}
            {Math.abs(metric.change)}%
          </span>
        )}
      </div>
    </div>
  );
};

interface PlatformMetricsProps {
  metrics: AnalyticsMetric[];
}

const PlatformMetrics: React.FC<PlatformMetricsProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {metrics.map(metric => (
        <MetricCard key={metric.key} metric={metric} />
      ))}
    </div>
  );
};

export default PlatformMetrics;